import React, { Component } from 'react'
import { connect } from 'react-redux'
import { ProjectListHeader } from '../../../components'
import { back, push } from '../../../actions/nav-actions'
import { fetchProjectingResults, fetchAllLinkedResources, removeResourceFromProject } from '../../../api'
import { getDictionary } from '../../../utils'

class EvaluateContext extends Component {
    state = {
        project: {},
        is_loading: false,
        error: undefined,
        data: []
    }
    constructor(props) {
        super(props);
        this.getParams = this.getParams.bind(this);
        this.client = getDictionary(props.dictionary);
        this.getText = this.getText.bind(this);
    }
    getText(tag, category = 'projecting_results') {
        return this.client.get(category, tag);
    }
    getParams() {
        return this.props.match.params || {};
    }
    componentDidMount() {
        this.loadData()
    }
    loadData = () => {
        const params = this.getParams();
        this.setState({ is_loading: true, error: undefined }, () => {
            fetchAllLinkedResources(this.props.user.token,
                params.organization,
                params.code
            )
                .then((data) => this.setState({ is_loading: false, data }))
                .catch(err => this.setState({ is_loading: false, error: err }))
        });
    }
    onRemove = (resource) => {
        if (window.confirm("Did you have sure about delete this Resource?")) {
            const params = this.getParams();
            removeResourceFromProject(this.props.user.token,
                resource.resource.key,
                {
                    project: params.code
                }
            ).then(data => {
                this.loadData()
            }).catch(err => this.setState({ is_loading: false, error: err }))
        }
    }
    render() {
        if (this.state.error) return <span>{this.state.error.message}</span>
        if (!this.state.data || this.state.is_loading) return <span>Loading data...</span>
        return (
            <React.Fragment>
                <ProjectListHeader title="RESOURCES" />
                <div style={{ border: '1px solid #CCC', borderRadius: '4px' }}>
                    <div style={{ padding: '16px' }}>
                        <b>Library</b>
                    </div>
                    {this.state.data.map((link, id) => {
                        return (
                            <Resource
                                onRemove={this.onRemove}
                                resource={link} key={id} />
                        )
                    })}
                </div>
            </React.Fragment>
        )
    }
}

const mapStateToProps = state => ({ ...state.localStorage, user: state.authReducer.user });

const mapDispatchToProps = dispatch => ({
    back() {
        dispatch(back())
    },
    push(routeName) {
        dispatch(push(routeName))
    }
})

function Resource(props) {
    return (
        <div style={{ borderTop: '1px solid #CCC', padding: '16px' }}>
            <a href={props.resource.resource.url} target="_blank">
                <span>{props.resource.resource.title}</span>
            </a>
            <br />
            <button style={{
                border: 0,
                paddingLeft: 0,
                backgroundColor: 'transparent',
                color: '#c51e48'
            }} onClick={() => props.onRemove(props.resource)}>Remove from Library</button>
        </div>
    )
}

export default connect(mapStateToProps, mapDispatchToProps)(EvaluateContext);


// WEBPACK FOOTER //
// ./src/routers/Projects/Formularies/Resources.js